import { createSlice } from '@reduxjs/toolkit';
export const iaDetailsSliceName = 'iaDetails';
export const {
  actions,
  reducer
} = createSlice({
  name: iaDetailsSliceName,
  initialState: {},
  reducers: {
    setIAState: (state, action) => {
      return Object.assign({}, state, action.payload);
    }
  }
});